// KARNIKAA variant gallery refresh for Horizon's native <variant-picker> controls.
(() => {
  let refreshTimer = null;
  let lastVariantId = '';

  const getVariantId = () => {
    const picker = document.querySelector('main variant-picker');
    const checkedRadio = picker?.querySelector('input[type="radio"][data-variant-id]:checked');
    if (checkedRadio?.dataset.variantId) return checkedRadio.dataset.variantId;

    const selectedOption = picker?.querySelector('select option:checked[data-variant-id]');
    if (selectedOption?.dataset.variantId) return selectedOption.dataset.variantId;

    const idInput = document.querySelector('main form[action*="/cart/add"] input[name="id"], main form[action*="/cart/add"] select[name="id"]');
    return idInput?.value || new URLSearchParams(window.location.search).get('variant') || '';
  };

  const refreshGallery = async () => {
    const variantId = getVariantId();
    if (!variantId || variantId === lastVariantId) return;
    lastVariantId = variantId;

    const currentGallery = document.querySelector('main media-gallery');
    if (!currentGallery) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.delete('section_id');

    try {
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Variant page request failed: ' + response.status);

      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGallery = parsed.querySelector('main media-gallery');
      const liveGallery = document.querySelector('main media-gallery');

      if (!nextGallery || !liveGallery || getVariantId() !== variantId) return;

      // Preserve the live gallery's section context while replacing the media markup.
      liveGallery.replaceWith(nextGallery);
      document.dispatchEvent(new CustomEvent('karnikaa:variant-gallery-updated', {
        detail: { variantId }
      }));
    } catch (error) {
      console.error('[KARNIKAA] Could not refresh variant gallery:', error);
      lastVariantId = '';
    }
  };

  const scheduleRefresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshGallery, 350);
  };

  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('variant-picker') ||
        event.target?.matches?.('input[name="id"], select[name="id"]')) {
      scheduleRefresh();
    }
  }, true);

  document.addEventListener('shopify:product:select', scheduleRefresh);
  document.addEventListener('karnikaa:variant-gallery-updated', () => {
    // Avoid an immediate duplicate fetch for the same selection.
    lastVariantId = getVariantId();
  });
})();